class DashboardsPrerequisiteService {
    constructor(hUser, brandServices, userPermissions) {
        this.hUser = hUser;
        this.brandServices = brandServices;
        this.userPermissions = userPermissions;
    }

    async canViewCompaasDashboard(brandId) {
        try {
            if (this.hUser.isTopLevelContext()) {
                return false;
            }

            const [brandServicesChecks, policyParser] = await Promise.all([
                this.brandServices.checkAll(brandId, [
                    this.brandServices.SERVICES.COMPAAS_DASHBOARD,
                ]),
                this.userPermissions.getBrandPolicy(brandId),
            ]);
            const hasViewCompaasPermission = policyParser.has(this.userPermissions.PERMISSIONS.ACCESS_COMPASS_DASHBOARD);
            const isCompaasDashboardEnabled = brandServicesChecks[this.brandServices.SERVICES.COMPAAS_DASHBOARD];

            return (
                isCompaasDashboardEnabled &&
                hasViewCompaasPermission
            );
        } catch (err) {
            console.error(err);
        }
    };

    async canViewHaloDashboard(entryBrandId) {
        const [
            isTeamSchedulingServiceEnabled,
            isHaloDashboardServiceEnabled
        ] = await Promise.all([
            this.brandServices.check(this.brandServices.SERVICES.TEAM_SCHEDULING, entryBrandId, true),
            this.brandServices.check(this.brandServices.SERVICES.HALO_DASHBOARD, entryBrandId),
            this.userPermissions.getBrandPolicy(this.hUser.getActiveBrandIdWithAccess())
        ]);

        if (!isTeamSchedulingServiceEnabled || !isHaloDashboardServiceEnabled) return false;

        return await this.userPermissions.hasPermissionOnBrandOrAnyChild(
            entryBrandId,
            this.userPermissions.PERMISSIONS.VIEW_HALO_DASHBOARD,
            this.userPermissions.PERMISSION_CATEGORIES.HARRI
        );
    }

    async canViewRiskDashboard(brandId) {
        const policyParser = await this.userPermissions.getBrandPolicy(brandId);

        if (!policyParser.hasAccess(this.userPermissions.ACCESS_TYPES.TEAM)) {
            return false;
        }

        try {
            const isRiskDashboardEnabled = await this.brandServices.check(
                this.brandServices.SERVICES.RISK_DETECTION,
                brandId
            );

            if (!isRiskDashboardEnabled) {
                return false;
            }

            return await this.userPermissions.hasPermissionOnBrandOrAnyChild(
                brandId,
                this.userPermissions.PERMISSIONS.ACCESS_RISK_DETECTION_DASHBOARD,
                this.userPermissions.PERMISSION_CATEGORIES.TEAM
            );
        } catch (err) {
            console.error(err);
        }
    }

    async canViewSentimentEngagementDashboard(brandId) {
        let isHarriEngageServiceEnabled;
        try {
            isHarriEngageServiceEnabled = await this.brandServices.check(
                this.brandServices.SERVICES.HARRI_ENGAGE,
                brandId
            );
        } catch (e) {
            console.error(e);
            return false;
        }

        if (!isHarriEngageServiceEnabled) return false;

        let hasViewTeamEngagementPermission;
        try {
            hasViewTeamEngagementPermission = await this.userPermissions.hasPermissionOnBrandOrAnyChild(
                brandId,
                this.userPermissions.PERMISSIONS.VIEW_TEAM_ENGAGEMENT,
                this.userPermissions.PERMISSION_CATEGORIES.TEAM
            );
        } catch (e) {
            console.error(e);
            return false;
        }

        return hasViewTeamEngagementPermission;
    }
}

DashboardsPrerequisiteService.$inject = ['hUser', 'brandServices', 'userPermissions'];
angular
    .module("harriApp")
    .service("dashboardsPrerequisiteService", DashboardsPrerequisiteService);
